import { useMount } from 'ahooks';
import { Layout, Select } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { usePage } from 'hooks';
import { useTranslation } from 'react-i18next';
import { UnderlineText } from '../../components/RevxTypography/index';
import { STATIC_PAGE_URL } from 'utils/constants';

export const Footer = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const theme = useAppSelector((state) => state.app.theme);
  const { isPlatformPage } = usePage();

  useMount(() => {
    if (process.env.REACT_APP_BRANCH_NAME) {
      const version = process.env.REACT_APP_BRANCH_NAME.split('/').pop() || '';
      localStorage.setItem('version', version);
      console.log(version);
    }
  });

  return (
    <div className="footer-container">
      <Layout.Footer className="app-footer shop">
        <div>
          {t('footer.copyright', { year: new Date().getFullYear() })}
          {/* {process.env.REACT_APP_BRANCH_NAME && (
            <span> version@{process.env.REACT_APP_BRANCH_NAME.split('/').pop()}</span>
          )} */}
        </div>
        <div className="app-footer-right">
          {!isPlatformPage && (
            <div hidden>
              <Select
                value={theme}
                onChange={(val) => {
                  dispatch.app.switchTheme(val);
                }}
                getPopupContainer={(e) => {
                  return e as HTMLElement;
                }}
              >
                <Select.Option value="default">Default Theme</Select.Option>
                <Select.Option value="org1">Org Demo Theme</Select.Option>
              </Select>
            </div>
          )}
          <div>
            <UnderlineText color="blue">
              <a
                href={`${STATIC_PAGE_URL}/privacy-policy`}
                target="_blank"
                rel="noreferrer"
              >
                {t('footer.privacyPolicy')}
              </a>
            </UnderlineText>
          </div>
          <div>
            <UnderlineText color="blue">
              <a href={`${STATIC_PAGE_URL}/`} target="_blank" rel="noreferrer">
                {t('footer.about')}
              </a>
            </UnderlineText>
          </div>
          <div>
            <UnderlineText color="blue">
              <a
                href={`${STATIC_PAGE_URL}/#contact`}
                target="_blank"
                rel="noreferrer"
              >
                {t('footer.contact')}
              </a>
            </UnderlineText>
          </div>
        </div>
      </Layout.Footer>
    </div>
  );
};
